/* unplugin-vue-components disabled */import { render } from "./RankListItem.vue?vue&type=template&id=2cb09145&scoped=true&ts=true"
import script from "./RankListItem.vue?vue&type=script&lang=ts"
export * from "./RankListItem.vue?vue&type=script&lang=ts"

import "./RankListItem.vue?vue&type=style&index=0&id=2cb09145&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb09145"]])

export default __exports__